import { useQuery } from '@tanstack/react-query';
import { CalendarClock, Receipt, Wallet } from 'lucide-react';

import { KPICard } from '@/components/composed/KPICard';
import { formatMoney } from '@/lib/format';
import { portalSummaryQuery } from '../api/portal-queries';

/*
 * Feature component: the three headline figures on the portal landing (Last
 * Billed Amount, Current Balance, Scheduled Payment), from the mockup. Consumes
 * the summary query and formats money via lib/format — never computes on money.
 * Scheduled Payment renders "None" when none is set (the mockup's wording).
 */
export function PortalSummaryCards() {
  const query = useQuery(portalSummaryQuery());
  const summary = query.data;

  const lastBilled = summary
    ? formatMoney(summary.lastBilledAmountMinor, summary.currency)
    : undefined;
  const currentBalance = summary
    ? formatMoney(summary.currentBalanceMinor, summary.currency)
    : undefined;
  const scheduledPayment = summary
    ? summary.scheduledPayment
      ? formatMoney(summary.scheduledPayment.amountMinor, summary.currency)
      : 'None'
    : undefined;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <KPICard label="Last Billed Amount" value={lastBilled} icon={Receipt} />
      <KPICard label="Current Balance" value={currentBalance} icon={Wallet} />
      <KPICard
        label="Scheduled Payment"
        value={scheduledPayment}
        icon={CalendarClock}
      />
    </div>
  );
}
